import { render, staticRenderFns } from "./Samba.vue?vue&type=template&id=4e3f9015&scoped=true&lang=pug&"
import script from "./Samba.vue?vue&type=script&lang=js&"
export * from "./Samba.vue?vue&type=script&lang=js&"
import style0 from "./Samba.vue?vue&type=style&index=0&id=4e3f9015&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3f9015",
  null
  
)

export default component.exports
import {QPage,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QBtn})
